var render, staticRenderFns
import script from "./ElectronicMoneyDetailMixin.vue?vue&type=script&lang=js&"
export * from "./ElectronicMoneyDetailMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports